<template>
    <section>
      <div class="container"  v-if="addOns.powerDevices">
        <div class="hero is-bold">
          <div class="hero-body" style="padding-left: 0px; padding-top: 0px">
            <div class="container">
              <h1 class="title" style="color:#3e8ed0">Power devices</h1>
              <h5 class="subtitle">Manage your power devices here. Each power device can be assigned to a single device.</h5>
            </div>
          </div>
        </div>
        <b-table :data="tableData" striped>
          <template slot-scope="props">
            <b-table-column field="name" label="Power device name"  class="topPadding">
              {{props.row.name}}
            </b-table-column>
            <b-table-column field="poweroff" label="Power-off time" centered>
              <!--{{props.row.events[0].powerOffTime}}-->
              <b-timepicker
                :disabled="role !== 'admin' && role !== 'device' && isMigrated"
                @change.native="changePowerOffTime(props.row.id)"
                v-model="selectedPowerOffTimes[props.row.id]"
                rounded
                placeholder="Click to select..."
                icon="clock"
                :enable-seconds="secs"
                hour-format="24"
                :locale="locale"
                position="is-top-right">
            </b-timepicker>
            </b-table-column>
            <b-table-column field="poweron" label="Power-on time" centered>
              <b-timepicker
                :disabled="role !== 'admin' && role !== 'device' && isMigrated"
                @change.native="changePowerOnTime(props.row.id)"
                v-model="selectedPowerOnTimes[props.row.id]"
                rounded
                placeholder="Click to select..."
                icon="clock"
                :enable-seconds="secs"
                hour-format="24"
                :locale="locale"
                position="is-top-right">
            </b-timepicker>
            </b-table-column>
            <b-table-column field="id" label="Type" centered>
              <b-select :disabled="role !== 'admin' && role !== 'device' && isMigrated" v-model="selectedTypes[props.row.id]" @change.native="changeType($event, props.row.id)">
              <option v-for="(type, id) of types" :key="id" :value="type.id">
                {{type.name}}
              </option>
            </b-select>
            </b-table-column>
            <b-table-column field="id" label="Status" centered class="topPadding">
                <!-- <b-button type="is-info" icon-left="edit" size="is-small" @click="editCampaignModal(props.index, props.row.id)"></b-button>
            <b-button type="is-danger" icon-left="trash" size="is-small" @click="confirmRemoveCampaign(props.row.id, props.row.name, props.index)"></b-button>
                -->
                <b-switch :disabled="role !== 'admin' && role !== 'device' && isMigrated" v-model="isEnabled[props.row.id]" @change.native="changeStatus(props.row.id)"></b-switch>
            </b-table-column>
          </template>
        </b-table>
      </div>
      <div v-else class="container">
      </div>
    </section>
  </template>
<script>

export default {
  name: 'PowerDevices',
  data: () => {
    return {
      tableData: [],
      selectedClusters: {},
      // powerDevicesAddOn: false,
      selectedPowerDevices: {},
      selectedPowerOffTimes: {},
      selectedPowerOnTimes: {},
      selectedTypes: {},
      types: [{ id: 1, name: 'Every day' }, { id: 2, name: 'Weekdays' }, { id: 3, name: 'Weekend' }],
      isEnabled: {},
      locale: 'es-ES',
      secs: false
    }
  },
  computed: {
    powerDevices () {
      return this.$store.state.powerDevices
    },
    addOns () {
      return this.$store.state.addOns
    },
    workspaceId () {
      return this.$store.state.workspaceId
    },
    role () {
      return this.$store.state.role
    },
    userId () {
      return this.$store.state.uid
    },
    isMigrated () {
      return !this.getNotMigrated().includes(this.$store.state.uid)
    }
  },
  mounted: function () {
    /* if (this.$store.state.addOns !== null) {
      if (this.$store.state.addOns.powerDevices === true) {
        this.powerDevicesAddOn = true
      }
    } */
    if (this.powerDevices) {
      for (let device in this.powerDevices) {
        this.tableData.push({ id: device, ...this.powerDevices[device] })
        if (this.powerDevices[device].events !== undefined) {
          if (this.powerDevices[device].events[0].powerOffTime !== undefined) {
            this.selectedPowerOffTimes[device] = new Date(2000, 12, 12, this.powerDevices[device].events[0].powerOffTime.split(':')[0], this.powerDevices[device].events[0].powerOffTime.split(':')[1], 0)
          }
          if (this.powerDevices[device].events[0].powerOnTime !== undefined) {
            this.selectedPowerOnTimes[device] = new Date(2000, 12, 12, this.powerDevices[device].events[0].powerOnTime.split(':')[0], this.powerDevices[device].events[0].powerOnTime.split(':')[1], 0)
          }
          if (this.powerDevices[device].events[0].type !== undefined) {
            this.selectedTypes[device] = this.powerDevices[device].events[0].type
          }
          if (this.powerDevices[device].events[0].status !== undefined) {
            this.isEnabled[device] = this.powerDevices[device].events[0].status
          }
        }
      }
    }
    if (this.tableData.length > 0) {
      this.tableData.sort(this.compareNames)
    }
  },
  watch: {
    powerDevices (devices) {
      this.tableData = []
      this.selectedPowerOffTimes = {}
      this.selectedPowerOnTimes = {}
      this.selectedTypes = {}
      this.isEnabled = {}
      for (let device in devices) {
        this.tableData.push({ id: device, ...this.powerDevices[device] })
        if (this.powerDevices[device].events !== undefined) {
          if (this.powerDevices[device].events[0].powerOffTime !== undefined) {
            this.selectedPowerOffTimes[device] = new Date(2000, 12, 12, this.powerDevices[device].events[0].powerOffTime.split(':')[0], this.powerDevices[device].events[0].powerOffTime.split(':')[1], 0)
          }
          if (this.powerDevices[device].events[0].powerOnTime !== undefined) {
            this.selectedPowerOnTimes[device] = new Date(2000, 12, 12, this.powerDevices[device].events[0].powerOnTime.split(':')[0], this.powerDevices[device].events[0].powerOnTime.split(':')[1], 0)
          }
          if (this.powerDevices[device].events[0].type !== undefined) {
            this.selectedTypes[device] = this.powerDevices[device].events[0].type
          }
          if (this.powerDevices[device].events[0].status !== undefined) {
            this.isEnabled[device] = this.powerDevices[device].events[0].status
          }
        }
      }
      if (this.tableData.length > 0) {
        this.tableData.sort(this.compareNames)
      }
    }
  },
  methods: {
    changeType (event, id) {
      if (!this.getNotMigrated().includes(this.userId)) {
        this.$store.state.database.ref('/neoslide/powerDevices/' + this.workspaceId + '/' + id + '/events/0').update({
          type: parseInt(event.target.value)
        })
      } else {
        this.$store.state.database.ref('/powerDevices/' + this.userId + '/' + id + '/events/0').update({
          type: parseInt(event.target.value)
        })
      }
    },
    changeStatus (id) {
      if (!this.getNotMigrated().includes(this.userId)) {
        this.$store.state.database.ref('/neoslide/powerDevices/' + this.workspaceId + '/' + id + '/events/0').update({
          status: this.isEnabled[id]
        })
      } else {
        this.$store.state.database.ref('/powerDevices/' + this.userId + '/' + id + '/events/0').update({
          status: this.isEnabled[id]
        })
      }
    },
    changePowerOffTime (id) {
      if (this.selectedPowerOffTimes[id] !== undefined) {
        let offTimeArray = this.selectedPowerOffTimes[id].toString().split(' ')[4].split(':')
        let offTime = offTimeArray[0] + ':' + offTimeArray[1]
        if (!this.getNotMigrated().includes(this.userId)) {
          this.$store.state.database.ref('/neoslide/powerDevices/' + this.workspaceId + '/' + id + '/events/0').update({
            powerOffTime: offTime
          })
        } else {
          this.$store.state.database.ref('/powerDevices/' + this.userId + '/' + id + '/events/0').update({
            powerOffTime: offTime
          })
        }
      }
    },
    changePowerOnTime (id) {
      if (this.selectedPowerOnTimes[id] !== undefined) {
        let onTimeArray = this.selectedPowerOnTimes[id].toString().split(' ')[4].split(':')
        let onTime = onTimeArray[0] + ':' + onTimeArray[1]
        if (!this.getNotMigrated().includes(this.userId)) {
          this.$store.state.database.ref('/neoslide/powerDevices/' + this.workspaceId + '/' + id + '/events/0').update({
            powerOnTime: onTime
          })
        } else {
          this.$store.state.database.ref('/powerDevices/' + this.userId + '/' + id + '/events/0').update({
            powerOnTime: onTime
          })
        }
      }
    },
    compareNames (a, b) {
      if (a.name < b.name) {
        return -1
      }
      if (a.name > b.name) {
        return 1
      }
      return 0
    }
  }
}
</script>
<style scoped>
.topPadding {
  padding-top: 14px
}
</style>



// WEBPACK FOOTER //
// src/components/powerdevices/PowerDevices.vue